import React, {useContext} from "react";

import {
    Checkbox, Radio, FormControlLabel, FormGroup, FormLabel,
    Typography,
    RadioGroup,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import styles from './style.module.css'
import {ChevronDown} from "react-feather"
import {observer} from "mobx-react";
import {Paper} from "../../../../../../common/components/libs";
import {OrderStatus} from "../../../../../../services/orders/models";
import {PaymentProviderType} from "../../../../../../services/general/models";
import {DeliveryType} from "../../../../../../services/menu/models";
import {Trans, useTranslation} from "react-i18next";
import TimePicker from "../../TimePicker";
import OrdersStoreContext from "../../store/context";


const FilterForCard = () => {
    const ordersStore = useContext(OrdersStoreContext);
    const filter = ordersStore.filter;
    const {i18n, t} = useTranslation(["general", "orders"]);
    const locale = i18n.language;


    const handleDeliveryTypeOnChange = (type: DeliveryType) => () => {
        const index = filter.deliveryTypes.indexOf(type);
        let newValue = [];

        if (index < 0) {
            newValue = [
                ...filter.deliveryTypes, type
            ]
        } else {
            newValue = filter.deliveryTypes.filter(item => item !== type);
        }
        ordersStore.setOrdersFilter({
            ...filter,
            deliveryTypes: [
                ...newValue
            ]
        });
        ordersStore.reloadOrders();
    };

    const handlePaymentTypeOnChange = (type: PaymentProviderType) => () => {
        const index = filter.paymentTypes.indexOf(type);
        let newValue = [];

        if (index < 0) {
            newValue = [
                ...filter.paymentTypes, type
            ]
        } else {
            newValue = filter.paymentTypes.filter(item => item !== type);
        }
        ordersStore.setOrdersFilter({
            ...filter,
            paymentTypes: [
                ...newValue
            ]
        });
        ordersStore.reloadOrders();
    };

    const handleStatusTypeOnChange = (type: OrderStatus) => () => {
        const index = filter.statuses.indexOf(type);
        let newValue = [];

        if (index < 0) {
            newValue = [
                ...filter.statuses, type
            ]
        } else {
            newValue = filter.statuses.filter(item => item !== type);
        }
        ordersStore.setOrdersFilter({
            ...filter,
            statuses: [
                ...newValue
            ]
        });
        ordersStore.reloadOrders();
    };

    const handlePaymentStatusOnChange = (paymentStatus: boolean) => () => {

        ordersStore.setOrdersFilter({
            ...filter,
            isPaid: paymentStatus,
        });
        ordersStore.reloadOrders();
    };
    const currentStatuses = [OrderStatus.new, OrderStatus.canceled, OrderStatus.accepted]


    return (
        <Paper style={{
            marginBottom: 10,
            display: "flex",
            alignItems: 'flex-start',
            flexDirection: 'column',
            padding: 20,
            maxWidth: 400,
            width: "100%"
        }}>
            <div className={styles.tooltipBlock}>
                <Typography className={styles.header}>
                    <span>{t("orders:filter.timePeriod")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <TimePicker/>
                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock} style={{marginTop: 10}}>
                <Typography className={styles.header}>
                    <span>{t("orders:filter.orderStage")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("orders:filter.selectOrderStage")}</FormLabel>
                        <FormGroup>
                            <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "space-between",
                                maxWidth: "400px"
                            }}>
                                {Object.values(currentStatuses).map(item => {
                                    return (
                                        <FormControlLabel
                                            key={item}
                                            control={
                                                <Checkbox
                                                    checked={filter.statuses.indexOf(item) >= 0}
                                                    onChange={handleStatusTypeOnChange(item)}
                                                    value={item}
                                                />
                                            }
                                            label={t(`orders:orderStatus.${item}`)}
                                            style={{width: "40%"}}
                                        />

                                    )
                                })}
                            </div>
                        </FormGroup>

                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock} style={{marginTop: 10}}>
                <Typography className={styles.header}>
                    <span>{t("orders:deliveryType")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("orders:filter.selectDeliveryType")}</FormLabel>
                        <FormGroup>
                            {Object.values(DeliveryType).map(item => {
                                return (
                                    <FormControlLabel
                                        key={item}
                                        control={
                                            <Checkbox
                                                checked={filter.deliveryTypes.indexOf(item) >= 0}
                                                onChange={handleDeliveryTypeOnChange(item)}
                                                value={item}
                                            />
                                        }
                                        label={t(`orders:deliveryTypes.${item}`)}
                                    />
                                )
                            })}
                        </FormGroup>
                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock} style={{marginTop: 10}}>
                <Typography className={styles.header}>
                    <span>{t("orders:paymentType")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("orders:filter.selectPaymentType")}</FormLabel>
                        <FormGroup>
                            {Object.values(PaymentProviderType).map(item => {
                                return (
                                    <FormControlLabel
                                        key={item}
                                        control={
                                            <Checkbox
                                                checked={filter.paymentTypes.indexOf(item) >= 0}
                                                onChange={handlePaymentTypeOnChange(item)}
                                                value={item}
                                            />
                                        }
                                        label={t(`orders:paymentProviderType.${item}`)}
                                    />
                                )
                            })}
                        </FormGroup>
                    </FormControl>
                </Paper>
            </div>
            <div className={styles.tooltipBlock} style={{marginTop: 10}}>
                <Typography className={styles.header}>
                    <span>{t("orders:paymentState")}</span><ChevronDown size={14}/>
                </Typography>
                <Paper className={styles.tooltipBlockContent}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">{t("orders:filter.selectType")}</FormLabel>
                        <RadioGroup>
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === false}
                                        onChange={handlePaymentStatusOnChange(false)}
                                        value={t("orders:notPaid")}
                                    />
                                }
                                label={t("orders:notPaid")}
                            />
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === true}
                                        onChange={handlePaymentStatusOnChange(true)}
                                        value={t("orders:paid")}
                                    />
                                }
                                label={t("orders:paid")}
                            />
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={filter.isPaid === null}
                                        onChange={handlePaymentStatusOnChange(null)}
                                        value={t("orders:filter.all")}
                                    />
                                }
                                label={t("orders:filter.all")}
                            />
                        </RadioGroup>
                    </FormControl>
                </Paper>
            </div>
        </Paper>
    )

};


export default observer(FilterForCard)


